/* eslint-disable react/jsx-props-no-spreading */
import React from "react";
import AIObjectPanel from "../../hubspot/new-flow/steps/AIObjectPanel";

interface GoogleCalendarNewFlowProps {
  isConnected?: boolean;
  integrationId?: string;
}

const GoogleCalendarNewFlow = ({ isConnected, integrationId }: GoogleCalendarNewFlowProps) => (
  isConnected ? (
    <AIObjectPanel
      slug="meetings"
      providerKey="google-calendar"
      providerLabel="Google Calendar"
      isConnected={isConnected}
      integrationId={integrationId}
      onToggleSelected={() => {
        // For Google Calendar, we only support meetings
        // Toggle logic is handled by the AIObjectPanel component
      }}
    />
  ) : (
    null
  )
);

export default GoogleCalendarNewFlow;
